import { getActiveChannel } from '../authentication/utils'
import { get } from '../utils'

export default host => () =>
  get(`${host}/channels/${getActiveChannel()}/user/purchases?include=purchases.product.content;product.content;gift;gift.userReceiver`)
    .then(response => response.json())
    .then(json => json.data)
